import React from "react";
import { Link, useLocation } from "react-router-dom";
import { buildDrawerNav, findActiveItemKey, GROUP_ICON, statusLabel } from "./drawerNav";
import "./DropshippingModuleTabs.css";

// The always-visible module tab strip at the top of every Dropshipping In / Provider page (its
// original place, before it was consolidated into the Filter drawer's collapsible "Elakay
// Navigation" section). Built from the SAME nav data (drawerNavConfig/drawerNav) that still powers
// that drawer section -- one source of truth, two presentations, never a second/duplicated menu.
export default function DropshippingModuleTabs({ infoSource }) {
  const { pathname } = useLocation();
  const groups = React.useMemo(() => buildDrawerNav(infoSource), [infoSource, infoSource?.allSettings, infoSource?.userInfo]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!groups.length) return null;
  // Family/Admin/Associate can see both groups (Dropshipping In + Provider/Producer); show only the
  // one that matches where the Seller/Provider actually is right now, never both stacked together.
  const group = groups.find((g) => findActiveItemKey(g, pathname)) || groups[0];
  const activeItem = findActiveItemKey(group, pathname);

  return (
    <nav className="dmt" aria-label={group.label}>
      <ul className="dmt__list">
        {group.items.map((item) => {
          const ItemIcon = item.icon;
          const active = activeItem === item.key;
          const inert = item.status !== "active";
          return (
            <li key={item.key} className="dmt__item">
              {inert ? (
                <span className="dmt__link dmt__link--inert" aria-disabled="true">
                  <ItemIcon aria-hidden="true" /><span className="dmt__label">{item.label}</span>
                  <span className="dmt__badge">{statusLabel(infoSource, item.status)}</span>
                </span>
              ) : (
                <Link to={item.route} className={`dmt__link${active ? " is-active" : ""}`} aria-current={active ? "page" : undefined}>
                  <ItemIcon aria-hidden="true" /><span className="dmt__label">{item.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
